import styled from "styled-components";

export const WideBody = styled.div`
  display: flex; justify-content: center;
  /* height: 100%; */
  overflow-y: scroll;
`;